<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-expansion-panel
    v-model="panel"
    expand
  >
    <v-expansion-panel-content
      class="week__panel"
      v-for="(week, index) in weeks"
      v-show="!week.empty"
      expand
    >
      <template v-slot:header>
        <div class="week__header">
          <span class="mr-2 d-block body-2" style="height: 20px">{{getStartDateOfWeek(week.startDate)}}</span>
          <v-icon medium color="success">arrow_right_alt</v-icon>
          <span class="ml-2 mr-4 d-block body-2">{{getEndDateOfWeek(week.startDate)}}</span>
          <v-chip
            v-if="week.logs.length > 0"
            class="mx-4"
            color="blue lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('logs', index)"
          >
            <v-avatar
              left
              class="blue darken-2"
            >
              {{week.logs.length}}
            </v-avatar>
            Логи
          </v-chip>
          <v-chip
            v-if="week.reviews.length > 0"
            class="mx-4"
            color="green lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('reviews', index)"
          >
            <v-avatar
              left
              class="green darken-2"
            >
              {{week.reviews.length}}
            </v-avatar>
            {{ getReviewName(week.reviews) }} {{ getReviewLevel(week.reviews) }} лвл
          </v-chip>
          <v-chip
            v-if="week.reviews.filter((r) => r.data.bestReviewer).length > 0"
            class="mx-4"
            color="orange lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('bestReviewer', index)"
          >
            <v-avatar
              left
              class="orange darken-2"
            >
              {{week.reviews.filter((r) => r.data.bestReviewer).length}}
            </v-avatar>
            Лучший ревьювер
          </v-chip>
          <v-chip
            v-if="getInflatedMarksData(week).length > 0"
            class="mx-4"
            color="purple lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('inflatedMarks', index)"
          >
            <v-avatar
              left
              class="purple darken-2"
            >
              {{getInflatedMarksData(week).length}}
            </v-avatar>
            Добряк
          </v-chip>
          <v-chip
            v-if="week.warnings.length > 0"
            class="mx-4"
            color="red lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('warnings', index)"
          >
            <v-avatar
              left
              class="red darken-2"
            >
              {{week.warnings.length}}
            </v-avatar>
            Предупреждения
          </v-chip>
          <v-chip
            v-if="week.feedbacks.length > 0"
            class="mx-4"
            color="indigo lighten-1"
            text-color="white"
            small
            @click.stop="setVisibility('feedbacks', index)"
          >
            <v-avatar
              left
              class="indigo darken-2"
            >
              {{week.feedbacks.length}}
            </v-avatar>
            Фидбеки
          </v-chip>
          <v-chip
            v-if="week.vacation"
            class="mx-4"
            color="cyan darken-3"
            text-color="white"
            small
            @click.stop="setVisibility('vacation', index)"
          >
            <v-avatar
              left
              class="cyan darken-4"
            >
              <v-icon>self_improvement</v-icon>
            </v-avatar>
            Отпуск
          </v-chip>
          <v-chip
            v-if="week.drop.date !== null"
            class="mx-4"
            color="brown darken-2"
            text-color="white"
            small
            @click.stop="setVisibility('drop', index)"
          >
            <v-avatar
              left
              class="brown darken-4"
            >
              <v-icon middle>arrow_drop_down</v-icon>
            </v-avatar>
            Дроп
          </v-chip>
        </div>
      </template>
      <v-card v-if="panel[index] === true" class="pt-0 week__body">
        <Events v-show="visibility[index]['logs']" :events="week.logs" category="logs"></Events>
        <Events v-show="visibility[index]['reviews']" :events="week.reviews" category="reviews"></Events>
        <Events v-show="visibility[index]['warnings']" :events="week.warnings" category="warnings"></Events>
        <Events v-show="visibility[index]['feedbacks']" :events="week.feedbacks" category="feedbacks"></Events>
        <Events v-show="visibility[index]['vacation']" :events="[]" category="vacation"></Events>
        <Events v-show="visibility[index]['drop']" :events="[]" category="drop" :data="week.drop"></Events>
        <Events v-show="visibility[index]['bestReviewer']" :events="week.reviews.filter((r) => r.data.bestReviewer)" category="bestReviewer"></Events>
        <Events v-show="visibility[index]['inflatedMarks']" :events="getInflatedMarksData(week)" category="inflatedMarks"></Events>
      </v-card>
    </v-expansion-panel-content>
    <v-btn class="mx-2 btn--close-all" fab dark color="grey darken-1" @click.stop="closeAllPanels">
      <v-icon>unfold_less</v-icon>
    </v-btn>
  </v-expansion-panel>
</template>

<script>
  import Events from "./Events";

  export default {
    name: "Weeks",
    props: ["weeks"],
    components: {
      Events
    },
    data() {
      return {
        panel: [],
        visibility: []
      }
    },
    created() {
      this.initVisibility();
    },
    methods: {
      getReviewLevel(reviews) {
        const review = reviews[0] || null;

        if (!review) {
          return null;
        }

        switch (review.eventName) {
          case 'reviewForReviewer':
            return review.data.fromVolunteer ? review.data.examineeLevel : review.data.reviewerLevel;
          case 'reviewForExaminee':
            return review.data.examineeLevel;
          default:
            return null;
        }
      },
      getReviewName(reviews) {
        if (reviews.length > 0) {
          const review = reviews[0];

          if (review.data.fromVolunteer) {
            return 'Воло-ревью';
          }
        }

        return 'Ревью';
      },
      getStartDateOfWeek: function(startDateString) {
        return new Date(startDateString).toLocaleDateString("en-GB");
      },
      getEndDateOfWeek: function(startDateString) {
        const startDate = new Date(startDateString);
        startDate.setDate(startDate.getDate() + 6);

        return startDate.toLocaleDateString("en-GB");
      },
      getInflatedMarksData: function (week) {
        const marksData = [];

        for (const review of week.reviews) {
          if (review.eventName === 'reviewForReviewer') {
            for (const reviewNumber in review.data.marks) {
              for (const markData of review.data.marks[reviewNumber]) {
                if (markData.inflated) {
                  marksData.push({
                    examineeId: review.data.examineeId,
                    level: review.data.examineeLevel,
                    task: markData.taskNumber,
                  });
                }
              }
            }
          }
        }

        return marksData;
      },
      initVisibility: function () {
        this.visibility = [];

        for (let i = 0; i < this.weeks.length; i++) {
          this.visibility.push({
            logs: true,
            reviews: false,
            warnings: false,
            feedbacks: false,
            vacation: false,
            drop: false,
            bestReviewer: false,
            inflatedMarks: false
          });
        }
      },
      setVisibility: function(category, index) {
        const visibility = this.visibility[index];

        for (const cat in visibility) {
          this.visibility[index][cat] = false;
        }

        this.visibility[index][category] = true;
        this.openPanel(index);
      },
      openPanel: function(index) {
        const panel = this.panel.slice();
        panel[index] = true;
        this.panel = panel;
      },
      closeAllPanels: function() {
        this.panel = [];
        window.scrollTo(0,0);
      }
    }
  }
</script>

<style scoped>
  .week__panel {
    border-bottom: 1px solid #4CAF50 !important;
  }

  .week__header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .week__body {
    background-color: #444444;
  }

  .btn--close-all {
    position: fixed;
    right: 0;
    bottom: 10px;
  }
</style>
